// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__VwpdC","overlay":"styles_overlay__dDr1j"};